import Swiper, { EffectFade, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";

class SectionHero {
  constructor(el) {
    this.DOM = el;

    // header
    this.header = document.querySelector("header-mobile");
    this.header && this.changeHeaderMobileState();

    // slideshow
    const slideshow = this.DOM.querySelector(".section-hero__slideshow");

    this.slides = this.DOM.querySelectorAll('.section-hero__slideshow .swiper-slide')
    addEventListener(
      "DOMContentLoaded",
      () => slideshow && this.slideShow(slideshow)
    );

    this.header.addEventListener("close", () => {
      setTimeout(() => {
        // console.log("close")
        this.check();
      }, 0);
    });
  }

  changeHeaderMobileState() {
    if (!window.matchMedia("(max-width:991px)").matches) {
      if (this.header && this.DOM) {
        setTimeout(() => this.setElementsInWhite, 0);
        document.addEventListener("scroll", () => this.check());
      }
    }
  }

  check() {
    if (!window.matchMedia("(max-width:991px)").matches) {
      if (window.scrollY > this.DOM.clientHeight - 160) {
        this.setElementsInBlack();
      } else {
        this.setElementsInWhite();
      }
    }
  }

  setElementsInBlack() {
    this.header.isLight = false;
  }
  setElementsInWhite() {
    this.header.isLight = true;
  }

  /**
   *
   * @param {HTMLElements} items
   */
  slideShow(items) {

    if(this.slides.length <= 1){
        console.log("une seule image dans le slideshow")
        return
    }


    const swiper = new Swiper(items, {
      modules: [ EffectFade, Autoplay],
      slidesPerView: 1,
      speed: 3000,
      loop: true,
      autoplay : {
        delay : 3000,
      },
      watchSlidesProgress: true,
      spaceBetween: 0,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
     stopOnLastSlide: false,
     disableOnInteraction: false,
     pauseOnMouseEnter: false,
    });

   
  }

  static bind() {
    const sections = document.querySelectorAll(".section-hero");
    sections.forEach((section) => new SectionHero(section));
  }
}


SectionHero.bind()